import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import Project from 'src/app/models/Project';

import { ProjectState } from '../project.state';

@Component({
    selector: 'app-project-detail-info',
    templateUrl: './project-detail-info.component.html',
    styleUrls: ['./project-detail-info.component.scss'],
})
export class ProjectDetailInfoComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();
    @Select(ProjectState.projects) works$: Observable<Project[]>;
    work: Project;
    readonly typeLabels: Record<number, string> = {
        0: 'Custom',
        1: 'Website',
        2: 'Consultancy',
        3: 'Other',
        4: 'Hosting',
        5: 'Intern',
    };

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.route.params.subscribe((params) => {
                this.works$.subscribe((works) => {
                    this.work = works.filter((w) => w.uuid == params.id)[0];
                });
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    asYesNo(value: boolean | null | undefined): string {
        return value ? 'Yes' : 'No';
    }

    asTypeLabel(type?: number): string {
        if (type === null || type === undefined) return '—';
        return this.typeLabels[type] ?? '—';
    }

    asInvoiceMethodLabel(method?: string): string {
        switch (method) {
            case 'BY_TIME':
                return 'By time';
            case 'BY_ACCOUNT':
                return 'By account';
            case 'BY_SES':
                return 'By SES';
            default:
                return '—';
        }
    }

    fullName(firstName?: string, lastName?: string): string {
        const value = `${firstName || ''} ${lastName || ''}`.trim();
        return value || '—';
    }

    hasLocation(): boolean {
        const location = this.work?.location;
        return !!(location?.street || location?.number || location?.bus || location?.ext || location?.postal || location?.city || location?.country?.iso2);
    }

    getFileName(value?: string | null): string {
        const raw = String(value || '').trim();
        if (!raw) return '—';
        const normalized = raw.replace(/\\/g, '/');
        const parts = normalized.split('/').filter((part) => !!part);
        return parts.length ? parts[parts.length - 1] : raw;
    }
}
